import { useEffect, useState } from "react";
import { Eye, FileDown } from "lucide-react";
import { toast } from "sonner";
import api, { download, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const PdfPreviewDialog = ({ url, params, filename, title, open, onOpenChange }) => {
  const [src, setSrc] = useState("");
  const key = JSON.stringify(params || {});
  useEffect(() => {
    let href = "";
    if (open && url) {
      api.get(url, { params: JSON.parse(key), responseType: "blob" })
        .then((r) => { href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); setSrc(href); })
        .catch((e) => { toast.error(errMsg(e)); onOpenChange(false); });
    }
    return () => { if (href) URL.revokeObjectURL(href); setSrc(""); };
  }, [open, url, key]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="max-w-5xl h-[92vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <DialogHeader className="flex-row items-center justify-between gap-3 space-y-0 pr-8">
          <DialogTitle className="font-heading">Preview {title}</DialogTitle>
          <Button size="sm" onClick={() => download(url, params || {}, filename)} data-testid="preview-download-btn"><FileDown className="h-4 w-4 mr-1" />Download PDF</Button>
        </DialogHeader>
        {src ? <iframe title="preview" src={src} className="w-full flex-1 rounded-lg border" data-testid="pdf-preview-frame" /> : <p className="text-sm text-slate-400">Memuat preview...</p>}
      </DialogContent>
    </Dialog>
  );
};

export const PreviewButton = ({ url, params, filename, title, testId = "preview-btn", icon = false, size }) => {
  const [open, setOpen] = useState(false);
  const show = (e) => { e.stopPropagation(); setOpen(true); };
  return (
    <>
      {icon
        ? <Button size="icon" variant="ghost" title="Preview" onClick={show} data-testid={testId}><Eye className="h-4 w-4" /></Button>
        : <Button variant="outline" size={size} className="bg-white" onClick={show} data-testid={testId}><Eye className="h-4 w-4 mr-1" />Preview</Button>}
      <PdfPreviewDialog url={url} params={params} filename={filename} title={title} open={open} onOpenChange={setOpen} />
    </>
  );
};
